import { IModel, IAttribute } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { SqlSink } from './sql.copysink';
import { AzureSqlTableDataset } from 'app/model/dataset/azure-sql-table.dataset';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.azureSql.copySinkType,
    display: [],
    referable: true,
    tags: { datasetModel: [Metamodel.modelFor(AzureSqlTableDataset)] }
})
export class AzureSqlSink extends SqlSink {
    public static readonly MODEL: IModel;
    public static readonly WRITER_STORED_PROCEDURE_NAME: IAttribute;
    public static readonly WRITER_TABLE_TYPE: IAttribute;
}
